import React from 'react';
import { Box, styled } from '@mui/material';

export const HeaderContainer = styled(Box)(({ theme }) => ({ // eslint-disable-line
  width: '100%',
  position: 'relative',
  zIndex: 5,
}));
